// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'antd/lib/button';
import Transfer from 'antd/lib/transfer';
import 'antd/lib/transfer/style/css';
import message from 'antd/lib/message';
// COMPONENTS
import SessionTypeModal from './SessionTypeModal';
import SectionHeader from 'components/text/SectionHeader';
// APOLLO
import { graphql, compose } from 'react-apollo';
import currentUserQuery from 'ApolloClient/Queries/currentUser';
import sessionTypesQuery from 'ApolloClient/Queries/sessionTypes';
import saveOrganizationSessionTypes from 'ApolloClient/Mutations/saveOrganizationSessionTypes';

// CONSTANTS & DESTRCUTURING
// ====================================

// HELPER COMPONENTS
// ====================================
const SessionLabel = ({ item }) => (
  <span>
    {item.title}
    <span
      style={{
        marginLeft: 10,
        display: 'inline-block',
        height: 10,
        width: 10,
        backgroundColor: item.color,
        borderRadius: '50%',
      }}
    />
  </span>
);

// EXPORTED COMPONENT
// ====================================
class SessionTypesArea extends React.PureComponent {
  state = {
    targetKeys: [],
    selectedKeys: [],
    dataSource: [],
    loading: false,
  };

  getDataWithKeys = sessionTypes => sessionTypes.map(item => ({
    ...item,
    key: item._id,
  }));

  componentDidMount() {
    // antd tabs are weird, the don't always mount/unmount as expected, so we need to make sure we re-run the query here

    this.props.sessionTypesQuery
      .refetch()
      .then(res => {
        let dataWithKeys = this.getDataWithKeys(res.data.sessionTypes);
        this.setState({ dataSource: dataWithKeys });
      })
      .catch(err => console.log(err));
  }

  handleChange = (nextTargetKeys, direction, moveKeys) => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  componentWillReceiveProps(newProps) {
    const { sessionTypesQuery } = this.props;

    if (
      (!sessionTypesQuery.sessionTypes && newProps.sessionTypesQuery.sessionTypes)
      || newProps.sessionTypesQuery.sessionTypes.length !== sessionTypesQuery.sessionTypes.length
    ) {
      let dataWithKeys = this.getDataWithKeys(newProps.sessionTypesQuery.sessionTypes);
      this.setState({ dataSource: dataWithKeys });
    }

    if (newProps.currentUser.organization.sessionTypes) {
      let targetKeys = newProps.currentUser.organization.sessionTypes.map(item => item._id);
      this.setState({
        targetKeys,
      });
    }
  }

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });
  };

  filterOption = (inputValue, option) => option.title && option.title.toLowerCase().indexOf(inputValue) > -1;

  onClick = () => {
    this.setState({ loading: true });
    let variables = {
      sessionTypes: this.state.targetKeys,
    };
    let refetchQueries = [
      {
        query: currentUserQuery,
        variables: {},
      },
    ];
    this.props
      .saveOrganizationSessionTypes({ variables, refetchQueries })
      .then(res => {
        this.setState({ loading: false });
        message.success('Session types saved!');
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log(err);
      });

    // save target keys as the new selected session types for the organization
  };

  onNew = () => {
    message.success('Open modal to add a new session type');
  };

  render() {
    const { loading, sessionTypes } = this.props.sessionTypesQuery;

    if (loading) {
      return <div>Loading...</div>;
    }

    if (!sessionTypes) {
      return <div>No Session Types...</div>;
    }

    return (
      <div style={{ width: 650, maxWidth: '100%' }}>
        <SectionHeader>SESSION TYPES</SectionHeader>
        <SessionTypeModal {...this.props} />
        <Transfer
          dataSource={this.state.dataSource}
          titles={['Options', 'Your Selected Types']}
          showSearch
          listStyle={{
            width: 240,
            height: 400,
          }}
          operations={['ADD', 'REMOVE']}
          filterOption={this.filterOption}
          targetKeys={this.state.targetKeys}
          selectedKeys={this.state.selectedKeys}
          rowKey={record => record._id}
          onChange={this.handleChange}
          notFoundContent="EMPTY"
          searchPlaceholder="Search Session Types..."
          onSelectChange={this.handleSelectChange}
          footer={() => (
            <Button
              size="small"
              style={{ float: 'right', margin: 5 }}
              loading={this.state.loading}
              onClick={this.onClick}
            >
              {!this.state.loading ? 'Save' : 'Saving...'}
            </Button>
          )}
          render={item => <SessionLabel item={item} />}
        />
      </div>
    );
  }
}
export default compose(
  graphql(sessionTypesQuery, { name: 'sessionTypesQuery' }),
  graphql(saveOrganizationSessionTypes, {
    name: 'saveOrganizationSessionTypes',
  }),
)(SessionTypesArea);



// WEBPACK FOOTER //
// ./src/routes/app-studio/SessionTypesArea/index.js